/**
 * @description Root level component for the entire application. It provides data providers and logic, layout, and an outlet for pages to be rendered in
 */

import React from 'react';
import { PropTypes } from 'prop-types';

import { LicenseInfo } from '@mui/x-license';
import Layout from './Layout';
import QueryProvider from '../contexts/query';
import { UserSettingsProvider } from '../contexts/userSettings';
import { CSRFProvider } from '../contexts/csrf';
import IdleChecker from '../contexts/idleChecker';

LicenseInfo.setLicenseKey('7b58d68dd23c2ef4c628d46bde2ce65eTz05MTU1NCxFPTE3NDg2MTY2NDMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

const App = ({ children }) => (
  <CSRFProvider>
    <IdleChecker>
      <UserSettingsProvider>
        <Layout>
          <QueryProvider>
            {children}
          </QueryProvider>
        </Layout>
      </UserSettingsProvider>
    </IdleChecker>
  </CSRFProvider>
)

App.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
export default App;
